import styled from 'styled-components'
import { theme } from './../../common'
import { Button } from './../../components'

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(${({image}) => image});
    background-size: cover;
    background-position: center;
    height: 530px;
    position: relative;
`

export const StyledTitle = styled.h1`
    font-weight: bold;
    font-size: 3em;
    margin-bottom: 4%;
    text-transform: uppercase;
`

export const Cube = styled.div`
    border: 1px solid ${theme.blue};
    height: 110%;
    width: 60%;
    position: absolute;
`
export const StyledButton = styled(Button)``